<script>
import Validation from '@/plugins/validation'
import { Input, AutocompleteSelect, Textarea } from '@/components/formelements'
import DatePicker from '@/components/DatePicker'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Campaigns',
  data() {
    return {
      ...Validation,
      items: [
        {
          text: 'All',
          value: ''
        },
        {
          text: 'Active',
          value: 'Active',
        },
        {
          text: 'Inactive',
          value: 'Inactive',
        },
      ],
      campaignDialog: false,
      pretailerDialog: false,
      newCampaign: false,
      billingDialog: false,
      newBilling: false,
      pretailerPromoDialog: false,
      pretailerPromoSiteID: ''
    }
  },
  async mounted(){
    await this.$store.dispatch('campaigns/GET_ALL_CAMPAIGNS')
    await this.$store.dispatch('campaigns/GET_SITE_LIST')
    await this.$store.dispatch('campaigns/GET_PROMOTER_LIST')
    await this.$store.dispatch('campaigns/GET_BILL_RECIPIENT')
    await this.$store.dispatch('campaigns/GET_CAMPAIGN_TYPE')
  },
  components: {
    Input,
    AutocompleteSelect,
    Textarea,
    DatePicker
  },
  computed: {
    ...mapState({
      status: state => state.campaigns.status,
      search: state => state.campaigns.search,
      pretailerPromo: state => state.campaigns.pretailerPromo
    }),
    ...mapGetters({
      allCampaigns: 'campaigns/allCampaigns',
      siteList: 'campaigns/siteList',
      promoterList: 'campaigns/promoterList',
      billRecipients: 'campaigns/billRecipients',
      campaignTypes: 'campaigns/campaignTypes',
      campaignTemplates: 'campaigns/campaignTemplates',
      pretailers: 'campaigns/pretailers',
      templateTypes: 'campaigns/templateTypes',
    }),
  },
  watch: {
    status: async function(){
      await this.$store.dispatch('campaigns/GET_ALL_CAMPAIGNS')
    },
  },
  methods: {
    pretailerPromoHeaders() {
      return [
        {
          text: 'PRetailer ID',
          value: 'PRetailerID'
        },
        {
          text: 'PRetailer Name',
          value: 'PRetailerName'
        },
        {
          text: 'Promotion Type',
          value: 'PromotionTypeDescription'
        }
      ]
    },
    templateHeaders() {
      return [
        {
          text: 'PRetailer Template',
          value: 'displayName'
        },
        {
          text: 'Actions',
          value: 'actions'
        }
      ]
    },
    billingHeaders() {
      return [
        {
          text: 'ID',
          value: 'value'
        },
        {
          text: 'Entity Name',
          value: 'text'
        },
        {
          text: 'Actions',
          value: 'actions'
        }
      ]
    },
    headers() {
      return [
        {
          text: 'Associated Pretailer(s)',
          value: 'PRetailerName'
        },
        {
          text: 'Site ID',
          value: 'SiteID'
        },
        {
          text: 'Site/Promoter Account',
          value: 'SiteName'
        },
        {
          text: 'Campaign Name',
          value: 'CampaignName'
        },
        {
          text: 'Description',
          value: 'Description'
        },
        {
          text: 'Campaign ID',
          value: 'CampaignID'
        },
        {
          text: 'Access Start',
          value: 'CampaignStart'
        },
        {
          text: 'Access End',
          value: 'CampaignEnd'
        },
        {
          text: 'Billing Recipient',
          value: 'BillingEntityName'
        },
        {
          text: 'Primary Contact',
          value: 'PrimaryContactName'
        },
        {
          text: 'Primary Contact Email',
          value: 'PrimaryContactEmailAddress'
        },
        {
          text: 'Secondary Contact',
          value: 'SecondaryContactName'
        },
        {
          text: 'Secondary Contact Email',
          value: 'SecondaryContactEmailAddress'
        },      
        {
          text: 'Campaign Type',
          value: 'CampaignDealTypeDescription'
        },           
      ]
    },
    editBilling(item){
      this.$store.dispatch('campaigns/SET_BILL_EDITING', item)
    },
    async saveBilling(item){
      if (this.$refs.editBillingForm.validate()){
        await this.$store.dispatch('campaigns/UPDATE_BILLING', { BillingEntityName: this.$store.state.campaigns.editBilling ,BillingEntityID: item.value, status: 1})
      }
    },
    async deleteBilling(item){
      await this.$store.dispatch('campaigns/UPDATE_BILLING', { BillingEntityName: item.text ,BillingEntityID: item.value, status: 901})
    },
    async addNewBilling(){
      if (this.$refs.newBillingForm.validate()){
        await this.$store.dispatch('campaigns/INSERT_BILLING')
        await this.$store.dispatch('campaigns/GET_BILL_RECIPIENT')
        this.newBilling = false
      }
    },
    async createCampaign(){
      this.newCampaign = true 
      this.campaignDialog = true
      this.$store.dispatch('campaigns/RESET')
      await this.$store.dispatch('campaigns/GENERATE_CAMPAIGN_ID')
    },
    async clickedCampaign(e, {item}){
      this.$store.dispatch('campaigns/RESET')
      this.newCampaign = false
      this.campaignDialog = true
      await this.$store.dispatch('campaigns/GET_CAMPAIGN', { ID: item.CampaignID, siteID: item.SiteID, pretailer: item.PRetailerName})
    },
    async saveUpdate(){
      if(this.$refs.campaignForm.validate()) {
        if (this.newCampaign){
          await this.$store.dispatch('campaigns/INSERT_CAMPAIGN')
          await this.$store.dispatch('campaigns/GET_CAMPAIGN', { ID: this.$store.state.campaigns.CampaignID, siteID: this.$store.state.campaigns.SiteID })
          this.newCampaign = false
        } else {
          await this.$store.dispatch('campaigns/UPDATE_CAMPAIGN')
          if (this.$store.state.campaigns.SiteID != 0) await this.$store.dispatch('campaigns/UPDATE_CAMPAIGN_SITE')
          await this.$store.dispatch('campaigns/GET_ALL_CAMPAIGNS')
        }
      }
    },
    async getPretailer(){
      this.pretailerDialog = true
      await this.$store.dispatch('campaigns/GET_CAMPAIGN_TEMPLATES')
      await this.$store.dispatch('campaigns/GET_PRETAILERS')
      await this.$store.dispatch('campaigns/GET_TEMPLATE_TYPE')
    },
    async saveUpdateTemplate(){
      if(this.$refs.templateForm.validate()) {
        await this.$store.dispatch('campaigns/SAVE_CAMPAIGN_TEMPLATE')
        await this.$store.dispatch('campaigns/GET_CAMPAIGN_TEMPLATES')
      }
    },
    async deleteTemplate(item){
      await this.$store.dispatch('campaigns/DELETE_CAMPAIGN_TEMPLATE', item)
      await this.$store.dispatch('campaigns/GET_CAMPAIGN_TEMPLATES')
    },
    clickedTemplate(e, {item}){
      this.$store.dispatch('campaigns/SET_CURRENT_TEMPLATE', item)
    },
    async seePretailers(id){
      await this.$store.dispatch('campaigns/GET_PRETAILER_PROMO', id)
      this.pretailerPromoSiteID = id
      this.pretailerPromoDialog = true
    }
  }
}
</script>

<template>
  <v-form ref="searchForm" @keyup.native.enter="searchGo">
    <v-container fluid>
      <v-row justify="center">
        <v-col class="py-0" cols="12" sm="3"  >
          <Input form="campaigns" field="search" :maxlength="128" placeholder="" label="Search" />
        </v-col>
        <v-col class="py-0" cols="12" sm="3" >
          <AutocompleteSelect form="campaigns" field="status" placeholder="" label="Status" :items="items" />
        </v-col>
        <v-col class="d-flex justify-center" cols="12" md="3"  >
          <v-btn @click="createCampaign" color="primary"><v-icon left>mdi-plus-box</v-icon>Create New Campaign</v-btn>
        </v-col>
        <v-col class="d-flex justify-center" cols="12" md="3" >
          <v-btn color="primary" @click="billingDialog = true"><v-icon left>mdi-bank</v-icon>Billing Entity</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card>
            <p class="d-flex pt-2 justify-center primary--text">Double click Row to edit Campaign</p>
            <v-data-table
              :headers="headers()"
              :items="allCampaigns"
              :items-per-page="10"
              :search="search"
              @dblclick:row="clickedCampaign"
            >
              <template v-slot:item.PRetailerName="{ item }" >
                <span v-if="item.SiteID != '0'" @click="seePretailers(item.SiteID)" style="cursor: pointer" class="primary--text">
                  See All Pretailers
                </span>
                <span v-else >
                  {{ item.PRetailerName }}
                </span>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog persistent v-model="campaignDialog" max-width="800px">
        <v-card>
          <v-card-title class="primary--text" v-if="newCampaign">
            Create New Campaign
          </v-card-title>
          <v-card-title class="primary--text" v-else>
            Update Campaign
          </v-card-title>
          <v-card-text >
            <v-row>
              <v-col v-if="newCampaign || (!newCampaign && this.$store.state.campaigns.SiteID != 0)" class="py-0" cols="12" sm="5">
                <AutocompleteSelect dense form="campaigns" field="SiteID" placeholder="" label="Site" :items="siteList" />
              </v-col>
              <v-col v-if="newCampaign" class="d-flex justify-center" cols="12" sm="2">
                <h2>OR</h2>
              </v-col>
              <v-col v-if="newCampaign" class="py-0" cols="12" sm="5">
                <AutocompleteSelect dense form="campaigns" field="promoterListSelected" placeholder="" label="Promoter Account" :items="promoterList" />
              </v-col>
              <v-col cols="12" sm="6" v-if="!newCampaign && this.$store.state.campaigns.SiteID == 0">
                  <Input readonly dense form="campaigns" field="currentPretailer" :maxlength="128" placeholder="" label="Pretailer" />
              </v-col>
            </v-row>
            <v-divider></v-divider>
          </v-card-text>
          <v-form ref="campaignForm">
            <v-card-text class="py-0">
              <v-row>
                <v-col class="py-0" cols="12" sm="6">
                  <Input dense form="campaigns" field="CampaignName" :maxlength="128" :rules="[...required]" placeholder="" label="Campaign Name" />
                </v-col>
                <v-col class="py-0" cols="12" sm="6">
                  <Input dense readonly form="campaigns" field="CampaignID" :maxlength="128" placeholder="" label="Campaign ID" />
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" cols="12">
                  <Textarea dense form="campaigns" field="Description" placeholder="" label="Description" />
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" cols="12" sm="6">
                  <DatePicker form="campaigns" field="CampaignStartDate" :rules="[...required]" placeholder="" label="Access Start Date" />
                </v-col>
                <v-col class="py-0" cols="12" sm="6">
                  <DatePicker form="campaigns" field="CampaignEndDate" :rules="[...required]" placeholder="" label="Access End Date" />
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" cols="12" sm="6">
                  <AutocompleteSelect dense form="campaigns" field="CampaignDealTypeID" placeholder="" label="Campaign Type" :items="campaignTypes" />
                </v-col>
                <v-col class="py-0" cols="12" sm="6">
                  <AutocompleteSelect dense form="campaigns" field="BillingEntityID" placeholder="" label="Billing Recipient" :items="billRecipients" />
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" cols="12" sm="6">
                  <Input dense form="campaigns" field="PrimaryContactName" :maxlength="128" :rules="[...required]" placeholder="" label="Primary Contact" />
                </v-col>
                <v-col class="py-0" cols="12" sm="6">
                  <Input dense form="campaigns" field="PrimaryContactEmailAddress" :maxlength="128" placeholder="" label="Primary Contact Email" />
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" cols="12" sm="6">
                  <Input dense form="campaigns" field="SecondaryContactName" :maxlength="128" placeholder="" label="Secondary Contact" />
                </v-col>
                <v-col class="py-0" cols="12" sm="6">
                  <Input dense form="campaigns" field="SecondaryContactEmailAddress" :maxlength="128" placeholder="" label="Secondary Contact Email" />
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
          <v-card-actions >
            <v-row>
              <v-col class="d-flex justify-start px-5"  cols="12" sm="6">
                <v-btn v-if="!newCampaign && this.$store.state.campaigns.SiteID != 0" color="primary" @click="getPretailer">Pretailer Template</v-btn>
              </v-col>
              <v-col class="d-flex justify-end px-5" cols="12" sm="6">
                <v-btn class="mx-1" width="125" color="secondary" @click="campaignDialog = false">close</v-btn>
                <v-btn class="mx-1" width="125" color="primary" @click="saveUpdate" ><v-icon left>mdi-content-save</v-icon>save</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="billingDialog" width="700">
        <v-card>
          <v-card-title class="primary--text">
            Billing Entity <v-spacer></v-spacer> <v-icon @click="newBilling = !newBilling" color="primary" x-large>mdi-plus-circle</v-icon>
          </v-card-title>
          <v-card-text class="py-0" v-if="newBilling">
            <v-form ref="newBillingForm">
              <v-row class="d-flex justify-end">
                <v-col class="py-0" cols="12" sm="4">
                  <Input dense form="campaigns" field="newBilling" :rules="[...required]" :maxlength="128" placeholder="" label="New Billing Entity Name" />
                </v-col>
                <v-col class="py-0" cols="12" sm="3">
                  <v-btn width="100%" color="primary" @click="addNewBilling"><v-icon left>mdi-content-save</v-icon>Save</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-text>
            <v-data-table
              :headers="billingHeaders()"
              :items="billRecipients"
            >
              <template v-slot:item.text="{ item }" >
                <span v-if="!item.editing">
                  {{ item.text }}
                </span>
                <span v-else>
                  <v-form ref="editBillingForm" class="pt-5">
                    <Input dense form="campaigns" field="editBilling" :rules="[...required]" :maxlength="128" placeholder="" label="" />
                  </v-form>
                </span>
              </template>
              <template v-slot:item.actions="{ item }" >
                <span>
                  <v-icon class="px-1" v-if="!item.editing" @click="editBilling(item)" color="primary">mdi-pencil</v-icon>
                  <v-icon class="px-1" v-if="item.editing" @click="saveBilling(item)" color="primary">mdi-content-save</v-icon>
                  <v-icon class="px-1" @click="deleteBilling(item)" color="primary">mdi-trash-can</v-icon>
                </span>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions class="d-flex justify-end px-5 pb-5">
            <v-btn width="125" color="secondary" @click="billingDialog = false">close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent width="750" v-model="pretailerDialog">
        <v-card>        
          <v-card-title >
            PRetailer Templates
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6">
                <v-data-table
                  :headers="templateHeaders()"
                  :items="campaignTemplates"
                  :items-per-page="10"
                  @dblclick:row="clickedTemplate"
                >
                  <template v-slot:item.actions="{ item }" >
                    <span>
                      <v-icon class="px-1" @click="deleteTemplate(item)" color="primary">mdi-trash-can</v-icon>
                    </span>
                  </template>
                </v-data-table>
              </v-col>
              <v-col cols="12" sm="6">
                <v-form ref="templateForm">
                  <AutocompleteSelect dense form="campaigns" field="templatePretailerID" :rules="[...required]" placeholder="" label="Pretailer ID" :items="pretailers" />
                  <AutocompleteSelect dense form="campaigns" field="templateType" :rules="[...required]" placeholder="" label="Template Type" :items="templateTypes" />
                  <Input dense form="campaigns" field="templateURL" :rules="[...required]" :maxlength="128" placeholder="" label="Template URL" />
                  <Input dense form="campaigns" field="templateUnitLogo" :rules="[...required]" :maxlength="128" placeholder="" label="Ad Unit Logo" />
                  <Input dense form="campaigns" field="templatePageLogo" :rules="[...required]" :maxlength="128" placeholder="" label="Campaign Page Logo" />
                  <Input dense form="campaigns" field="templateTagNames"  :maxlength="128" placeholder="" label="Retailer Tag Names" />
                </v-form>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="d-flex justify-end px-5 pb-5" >
            <v-btn class="mx-1" width="125" color="secondary" @click="pretailerDialog = false">close</v-btn>
            <v-btn class="mx-1" width="125" color="primary" @click="saveUpdateTemplate" ><v-icon left>mdi-content-save</v-icon>save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent width="750" v-model="pretailerPromoDialog">
        <v-card>        
          <v-card-title >
            PRetailers for siteID <span class="px-2 primary--text"> {{ pretailerPromoSiteID }}</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="pretailerPromoHeaders()"
                  :items="pretailerPromo"
                >
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="d-flex justify-end px-5 pb-5" >
            <v-btn class="mx-1" width="125" color="secondary" @click="pretailerPromoDialog = false">close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-form>
</template>
